import PublicNavbar from "../components/PublicNavbar";
import "./system-pages.css";

export default function SystemPageShell({ eyebrow, title, copy, icon, children, actions }) {
  return (
    <div className="sl-system-page">
      <PublicNavbar />
      <main className="sl-system-main">
        <section className="sl-system-card">
          <div className="sl-system-content">
            {icon && <div className="sl-system-icon" aria-hidden="true">{icon}</div>}
            {eyebrow && <span className="sl-system-eyebrow">{eyebrow}</span>}
            <h1 className="sl-system-title">{title}</h1>
            {copy && <p className="sl-system-copy">{copy}</p>}
            {children}
            {actions && <div className="sl-system-actions">{actions}</div>}
          </div>
        </section>
      </main>
    </div>
  );
}
